export class MailingAddressResultDto {
  mailingAddress1: string;
  mailingAddress2: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  mailingCountry: string;
  propertyAddress: string;
  propertyCity: string;
  propertyState: string;
  propertyZip: string;
  propertyCountry: string;
  isMailingAddressSameAsPropertyAddress: boolean;

  //Transient fields
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;

  populateDisplayAddress(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const rec = this;
    if (rec.isMailingAddressSameAsPropertyAddress) {
      rec.address1 = this.propertyAddress;
      rec.address2 = '';
      rec.city = this.propertyCity;
      rec.state = this.propertyState;
      rec.country = this.propertyCountry;
      rec.postalCode = this.propertyZip;
    } else {
      rec.address1 = this.mailingAddress1;
      rec.address2 = this.mailingAddress2;
      rec.city = this.mailingCity;
      rec.state = this.mailingState;
      rec.country = this.mailingCountry;
      rec.postalCode = this.mailingZip;
    }
  }
}
